import {
  ChevronLeft,
  History,
  Loader,
  Mic,
  MoreHorizontal,
  Pin,
  Plus,
  Search,
  Square,
  Tag,
  Trash2,
  Undo2,
  X,
  type LucideIcon,
} from 'lucide-react';

/**
 * Symbole aus `lucide-react` — dasselbe Set wie in den anderen Projekten.
 *
 * Die Zeichnungen lagen vorher als eigene Pfade hier; sie waren zusammengesucht und
 * passten in Strichstärke und Rundung nicht zueinander. Der Aufrufweg bleibt
 * `<Icon name="…" />`, damit die Benennung im Quelltext deutsch und beschreibend
 * bleibt und nicht jede Stelle einen englischen Symbolnamen trägt.
 */

const icons = {
  plus: Plus,
  more: MoreHorizontal,
  back: ChevronLeft,
  close: X,
  pin: Pin,
  history: History,
  tag: Tag,
  trash: Trash2,
  undo: Undo2,
  search: Search,
  mic: Mic,
  stop: Square,
  wait: Loader,
} satisfies Record<string, LucideIcon>;

type Name = keyof typeof icons;

type Props = { name: Name; filled?: boolean; size?: number };

export function Icon({ name, filled = false, size = 18 }: Props): JSX.Element {
  const Glyph = icons[name];
  return (
    <Glyph
      className="ico"
      width={size}
      height={size}
      // Angepinntes ist gefüllt, alles andere gezeichnet — der Unterschied muss
      // auf einen Blick erkennbar sein.
      fill={filled ? 'currentColor' : 'none'}
      strokeWidth={1.6}
      aria-hidden="true"
    />
  );
}
